"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SelloutType_1 = require("./SelloutType");
/**
 * Encapsulates numbers of sellout items, products and sites for a given sellout type.
 *
 * @author Adam Drda
 */


var SelloutTypeWithItemCounts =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTypeWithItemCounts, _DomainObject_1$Domai);

  /**
   * @param type type of sellout
   * @param itemCount number of sellout items
   * @param productCount number of unique products in sellout items
   * @param siteIds set of IDs of sites in counted sellout items
   */
  function SelloutTypeWithItemCounts(type, itemCount, productCount, siteIds) {
    var _this;

    _classCallCheck(this, SelloutTypeWithItemCounts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTypeWithItemCounts).call(this));
    _this.type = type;
    _this.itemCount = itemCount;
    _this.productCount = productCount;
    _this.siteIds = siteIds;
    return _this;
  }
  /**
   * Converter from data-dictionary representation.
   */


  _createClass(SelloutTypeWithItemCounts, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutTypeWithItemCounts(mat.type, mat.itemCount, mat.productCount, mat.siteIds);
    }
  }]);

  return SelloutTypeWithItemCounts;
}(DomainObject_1.DomainObject);

exports.SelloutTypeWithItemCounts = SelloutTypeWithItemCounts;

SelloutTypeWithItemCounts.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTypeWithItemCounts.name);
  return {
    type: builder.senum('type', SelloutType_1.SelloutType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutType),
    itemCount: builder.num('itemCount'),
    productCount: builder.num('productCount'),
    siteIds: builder.setOf(builder.id('siteIds'))
  };
}();